/* Returns a percentage, between 0 and 100 */
export default function getFullness(scheduleInstance) {
  if (
    scheduleInstance.limit_total_hours === 0 &&
    scheduleInstance.current_total_hours === 0
  ) {
    return 0;
  }
  const fullness =
    scheduleInstance.limit_total_hours === 0
      ? 1
      : scheduleInstance.current_total_hours /
        scheduleInstance.limit_total_hours;
  return Math.round(fullness * 100);
}
